var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEuFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 45,
    viewBox: "0 0 66 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.8126 0H-1V44.8382H65.8126V0Z",
    fill: "#164194"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1114 6.32839H35.4616L33.5814 7.80954L34.3201 10.1659L32.4399 8.68475L30.5598 10.1659L31.2984 7.80954L29.4182 6.32839H31.7684L32.4399 4.10669L33.1114 6.32839Z",
    fill: "#FFED00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2457 36.2208H35.5287L33.6486 37.6346L34.3872 39.8563L32.507 38.5098L30.694 39.8563L31.4327 37.6346L29.4854 36.2208H31.8355L32.507 34.0664L33.2457 36.2208Z",
    fill: "#FFED00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5648 34.2682H42.915L41.0349 35.682L41.7735 37.9037L39.8934 36.4899L38.0132 37.9037L38.7518 35.682L36.8717 34.2682H39.2219L39.8934 32.1138L40.5648 34.2682Z",
    fill: "#FFED00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5648 8.348H42.915L41.0349 9.76182L41.7735 11.9835L39.8934 10.637L38.0132 11.9835L38.7518 9.76182L36.8717 8.348H39.2219L39.8934 6.1936L40.5648 8.348Z",
    fill: "#FFED00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.071 13.8016H48.354L46.541 15.2154L47.2125 17.5045L45.3995 16.0906L43.5194 17.5045L44.258 15.2154L42.3778 13.8016H44.6609L45.3995 11.6472L46.071 13.8016Z",
    fill: "#FFED00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.071 28.8148H48.354L46.541 30.2286L47.2125 32.5176L45.3995 31.1038L43.5194 32.5176L44.258 30.2286L42.3778 28.8148H44.6609L45.3995 26.6604L46.071 28.8148Z",
    fill: "#FFED00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0854 21.2071H50.4356L48.5555 22.621L49.2941 24.8427L47.414 23.4962L45.5338 24.8427L46.2724 22.621L44.3923 21.2071H46.7425L47.414 19.0527L48.0854 21.2071Z",
    fill: "#FFED00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5907 8.348H27.9409L26.0608 9.76182L26.7994 11.9835L24.9193 10.637L23.0391 11.9835L23.7777 9.76182L21.8976 8.348H24.2478L24.9193 6.1936L25.5907 8.348Z",
    fill: "#FFED00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.286 13.8689H22.6362L20.7561 15.2827L21.4947 17.5045L19.6146 16.0906L17.7344 17.5045L18.473 15.2827L16.5929 13.8689H18.8759L19.6146 11.6472L20.286 13.8689Z",
    fill: "#FFED00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3387 21.2745H20.6218L18.7416 22.621L19.4802 24.91L17.6672 23.4962L15.7871 24.91L16.5257 22.621L14.6456 21.2745H16.9286L17.6672 19.0527L18.3387 21.2745Z",
    fill: "#FFED00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.286 28.8821H22.6362L20.7561 30.2959L21.4947 32.5176L19.6146 31.1038L17.7344 32.5176L18.473 30.2959L16.5929 28.8821H18.8759L19.6146 26.6604L20.286 28.8821Z",
    fill: "#FFED00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.725 34.2682H28.0081L26.1279 35.682L26.8666 37.9037L24.9864 36.5572L23.1734 37.9037L23.8449 35.682L21.9647 34.2682H24.3149L24.9864 32.1138L25.725 34.2682Z",
    fill: "#FFED00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuFlag);
export default __webpack_public_path__ + "static/media/eu_flag.41b42afd13a0b52c713b1a16fdf94b22.svg";
export { ForwardRef as ReactComponent };